import { useQuery } from "react-query";
import { getAgreementsByIDs } from "../../../../actions/CarrierAgreementMgmt/Agreements";

export const useAgreementDetails = ({ filterGrpParams }) => {
  return useQuery(["GetAgreementsByIDs", filterGrpParams], getAgreementsByIDs, {
    refetchOnWindowFocus: false,
    enabled: false,
  });
};
